'use strict';
(function () {
  angular.module('pentaApp').factory('clientUtils.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clientUtils');
  }
})();